import PortFlioAtRiskTypes from './portfolio-at-risk-report.type';

/** ***************GET PORTFOLIO AT RISK START ************* */
export const getportflioAtRiskStart = (getData: any) => ({
	type: PortFlioAtRiskTypes.PORTFLIO_AT_RISK_START,
	payload: getData,
});

export const getportflioAtRiskSuccess = (successData: any) => ({
	type: PortFlioAtRiskTypes.PORTFLIO_AT_RISK_SUCCESS,
	payload: successData,
});

export const getportflioAtRiskFailure = (failureData: any) => ({
	type: PortFlioAtRiskTypes.PORTFLIO_AT_RISK_FAILURE,
	payload: failureData,
});

export const getportflioAtRiskResponseResetStart = () => ({
	type: PortFlioAtRiskTypes.PORTFLIO_AT_RISK_RESPONSE_RESET,
});

export const getportflioAtRiskResponseChanged = () => ({
	type: PortFlioAtRiskTypes.PORTFLIO_AT_RISK_RESPONSE_CHANGED,
});
/** ***************GET PORTFOLIO AT RISK END ************* */

/** *********************LOAN_INFO_BASEDON_MEMBER START***** */
export const getLoanInfoBasedOnMemberStart = (getData: any) => ({
	type: PortFlioAtRiskTypes.GET_LOAN_INFO_BASEDON_MEMBER_START,
	payload: getData,
});

export const getLoanInfoBasedOnMemberSuccess = (successData: any) => ({
	type: PortFlioAtRiskTypes.GET_LOAN_INFO_BASEDON_MEMBER_SUCCESS,
	payload: successData,
});

export const getLoanInfoBasedOnMemberFailure = (failureData: any) => ({
	type: PortFlioAtRiskTypes.GET_LOAN_INFO_BASEDON_MEMBER_FAILURE,
	payload: failureData,
});

export const getLoanInfoBasedOnMemberResponseResetStart = () => ({
	type: PortFlioAtRiskTypes.GET_LOAN_INFO_BASEDON_MEMBER_RESPONSE_RESET,
});

export const getLoanInfoBasedOnMemberResponseChanged = () => ({
	type: PortFlioAtRiskTypes.GET_LOAN_INFO_BASEDON_MEMBER_RESPONSE_CHANGED,
});
/** *********************LOAN_INFO_BASEDON_MEMBER END ******** */
